import axiosLib from 'axios'
import log from 'loglevel'

export const requestDefaultJson = (
	{method, URIComplete, headers, data, axios = axiosLib, ...other},
	callbackStatus = callbackStatusDefault,
	callbackData = callbackDataDefault,
	callbackResolve = callbackResolveDefault,
	callbackError = callbackErrorDefault) => {

		return new Promise((resolve, reject) => {
			return axios.request(URIComplete, {
				method: method,
				headers: {
					...headers,
					"Content-Type": "application/json",
				},
				data: {
					...data
				},
				...other
			})
				.then(callbackStatus(resolve, reject))
				.then(callbackData(resolve, reject))
				.then(callbackResolve(resolve, reject))
				.catch(callbackError(resolve, reject));
		});
}

const callbackStatusDefault = (resolve, reject) => response => response.status !== 200 ? reject(response) : response;
const callbackDataDefault = (resolve, reject) => response => response.data;
const callbackResolveDefault = (resolve, reject) => response => resolve(response);
const callbackErrorDefault = (resolve, reject) => error => { reject(error); log.info(error); };

export {callbackStatusDefault, callbackDataDefault, callbackResolveDefault, callbackErrorDefault};